// ADVERTISING DATA STRUCTURE
// title: advertising title
// description: advertising subtitle
// theme: theme color that select theme color defined in theme.js
// weight: priority with which advertising is shown
// circles: array of circle values
// image: image path and position

// import { TS_DIGITAL_IMAGES } from "../../config";
import loginUser from "../../assets/img/login-user.png";

export const advertisement = {
  title: "v-pre-login.advertising.sustainability.title",
  description: "v-pre-login.advertising.sustainability.description",
  theme: "rose",
  weight: 5,
  circles: [
    {
      value: "140",
      valueType: "kg",
      description: "CO2 risparmiata",
      size: "large"
    },
    {
      value: "1,4",
      valueType: "mln",
      description: "stampe evitate",
      size: "medium"
    },
    {
      value: "400",
      description: "alberi salvati",
      size: "small"
    }
  ],
  image: {
    url: `${loginUser}`,
    top: "56px",
    right: "-48px"
  }
};
